export default __webpack_public_path__ + "static/media/11_gallery.4822b865.jpg";